import { App_Url_New, EMAIL_TEMPLATE_KEYS, LOB_IDS } from "@/shared/common/static";
import { AddonsCommon } from "@/shared/components/AddonsCommon";
import QuoteList from "@/shared/components/QuoteList/QuoteList";
import { SendQuoteEmailButton } from "@/shared/components/SendQuoteEmailButton";
import { AddQuoteProduct } from "../config/quoteProducts.config";

const motorAddonsEndpoint = App_Url_New.ApiEndPoint.addOnsApiMasterMotor;
const travelAddonsEndpoint = App_Url_New.ApiEndPoint.addOnsApiMasterTravel;
const healthAddonsEndpoint = App_Url_New.ApiEndPoint.addOnsApiMasterHealth;
const lifeAddonsEndpoint = App_Url_New.ApiEndPoint.addOnsApiMasterLife;

const getAddonsEndpoint = (lobId: number) =>
  lobId === LOB_IDS.MOTOR
    ? motorAddonsEndpoint
    : lobId === LOB_IDS.LIFE
      ? lifeAddonsEndpoint
      : lobId === LOB_IDS.TRAVEL
        ? travelAddonsEndpoint
        : healthAddonsEndpoint;

const getUploadLinkByLob = (lobId: number) => {
  const baseUrl =
    import.meta.env.VITE_APP_INSUREHUB_FRONTEND_URL ||
    import.meta.env.VITE_APP_FRONTEND_URL ||
    "https://protego2.nexsysit.co.in";

  if (lobId === LOB_IDS.MOTOR) {
    return `${baseUrl}${App_Url_New.D2CPageUrl.insurance.carGetQuote}`;
  }
  if (lobId === LOB_IDS.HEALTH) {
    return `${baseUrl}${App_Url_New.D2CPageUrl.insurance.healthGetQuote}`;
  }
  if (lobId === LOB_IDS.LIFE) {
    return `${baseUrl}${App_Url_New.D2CPageUrl.insurance.lifeGetQuote}`;
  }
  return `${baseUrl}${App_Url_New.D2CPageUrl.insurance.travelGetQuote}`;
};

type Props = {
  product: AddQuoteProduct & { lobId: number };
  fetchKey: string;
  onSelectQuote: (quote: any) => void;
  isReadOnly?: boolean;
  clientEmail?: string;
  clientName?: string;
};

export const QuotesListSection = ({
  product,
  fetchKey,
  onSelectQuote,
  isReadOnly = false,
  clientEmail = "",
  clientName = "Customer",
}: Props) => (
  <div className="broker-compact-quotes mt-1 flex items-start gap-3">
    <style>{`
      .broker-compact-quotes .quote-list-grid {
        display: block !important;
        columns: 2;
        column-gap: 12px;
      }
      .broker-compact-quotes .quote-list-grid > * {
        break-inside: avoid;
        margin-bottom: 10px;
        display: inline-block;
        width: 100%;
      }
      @media (max-width: 1100px) {
        .broker-compact-quotes .quote-list-grid {
          columns: 1 !important;
        }
      }
    `}</style>

    <div className="min-w-0 flex-1">
      <QuoteList
        compact
        columns={2}
        showCompareBar={!isReadOnly}
        LOB_ID={product.lobId}
        fetchKey={fetchKey}
        isReadOnly={isReadOnly}
        disableBuyNow={isReadOnly}
        onBuyNow={onSelectQuote}
      />
    </div>

    <div className="sticky top-3 w-72 shrink-0 space-y-3">
      <AddonsCommon
        compact
        disabled={isReadOnly}
        apiEndpoint={getAddonsEndpoint(product.lobId)}
        updateSessionEndpoint={App_Url_New.ApiEndPoint.updateSession}
        LOB_ID={product.lobId}
      />
      <SendQuoteEmailButton
        disabled={isReadOnly}
        email={clientEmail}
        fullName={clientName}
        activeStep={3}
        uploadLink={getUploadLinkByLob(product.lobId)}
        apiEndpoint={App_Url_New.ApiEndPoint.quoteEmailSend}
        templateKey={EMAIL_TEMPLATE_KEYS.GET_QUOTE_EMAIL}
      />
    </div>
  </div>
);
